import Icon, { IconColors, IconTypes } from '../icon/Icon';
import { TextWrapper, Wrapper } from './Button.styles';

export interface ButtonProps {
  className?: string;
  disabled?: boolean;
  icon?: IconTypes;
  iconColor?: IconColors;
  kind:
    | 'primary'
    | 'secondary'
    | 'inverted'
    | 'danger'
    | 'duplicate'
    | 'save'
    | 'edit'
    | 'cancel'
    | 'request';
  onClick?: (any?) => void;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  text?: string;
  tooltip?: string;
  type?: 'button' | 'submit';
}

const Button = ({
  className,
  disabled = false,
  icon,
  iconColor = 'white',
  kind = 'primary',
  onClick,
  size = 'lg',
  text,
  tooltip,
  type = 'button',
}: ButtonProps): JSX.Element => (
  <Wrapper
    className={className}
    data-tip={tooltip}
    disabled={disabled}
    data-kind={kind}
    icon={icon}
    onClick={onClick}
    size={size}
    text={text}
    type={type}
  >
    {text && (
      <TextWrapper icon={icon} size={size}>
        {text}
      </TextWrapper>
    )}
    {icon && <Icon type={icon} size={size} color={iconColor} />}
  </Wrapper>
);

export default Button;
